import service from "./service"

const acceptHrInvitation = async (data) => {
    return service(data)
}

export default acceptHrInvitation
